import { render, staticRenderFns } from "./tableSaleDocumentary.vue?vue&type=template&id=2b17c8d9&"
import script from "./tableSaleDocumentary.vue?vue&type=script&lang=js&"
export * from "./tableSaleDocumentary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports